<template>
  <div class="ol-item-container">
    <div class="oli-row-container">
      <span>{{ item.productName }}</span>
      <div
        v-if="item.showFilter"
        class="oli-input-container"
      >
        <input
          class="od-extra-info-input"
          type="text"
          placeholder="W"
          @change="changeNewOrderValue('width', item.productId, $event.target.value)"
        >
        <input
          class="od-extra-info-input"
          type="text"
          placeholder="H"
          @change="changeNewOrderValue('height', item.productId, $event.target.value)"
        >
        <input
          class="od-extra-info-input"
          type="text"
          placeholder="T"
          @change="changeNewOrderValue('thickness', item.productId, $event.target.value)"
        >
      </div>
      <div class="grid-column ai-c gap-16">
        <span class="od-quantity">
          <button @click="changeNewOrderValue('sub', item.productId)">
            -
          </button>
          <span>{{ item.quantity }}</span>
          <button @click="changeNewOrderValue('add', item.productId)">
            +
          </button>
        </span>
        <button
          class="od-delete-button"
          @click="changeNewOrderValue('remove', item.productId);"
        >
          <img
            src="@shared/assets/img/general/trash-white.png"
            alt="x"
            class="od-delete"
          >
        </button>
        <div class="oli-title">
          ${{ itemPrice }}
        </div>
      </div>
    </div>
    <div class="oli-row-container">
      <div class="oli-select-container">
        <SACDropdown
          placeholder="Select Discount"
          :options="discountCodes"
          :value="item.discountId"
          field="discount"
          :change="handleDiscountSelect"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

import orderMixin from '@shared/mixins/orderMixin';

import SACDropdown from '@shared/components/sac/SACDropdown.vue';

export default {
  name: 'OrderLineItem',
  components: {
    SACDropdown,
  },
  mixins: [orderMixin],
  props: {
    item: Object,
  },
  data() {
    return {};
  },
  computed: {
    discountCodes() {
      return this.allDiscountCodes.map((dc) => ({
        label: dc.description,
        value: dc.discountId,
      }));
    },
    itemPrice() {
      const {
        price,
        quantity,
        discount,
      } = this.item;
      let itemPrice = price * quantity;
      if (discount) {
        itemPrice -= discount.discountAmount;
      }
      return itemPrice;
    },
  },
  methods: {
    handleDiscountSelect(field, value) {
      const newOrder = cloneDeep(this.newOrder);
      const discount = this.allDiscountCodes.find((dc) => dc.discountId === value);
      const newOrderItems = newOrder.orderItems.map((item) => {
        const i = item;
        if (item.productSku === this.item.productSku) {
          i.discountId = value;
          i.discount = discount;
        }
        return i;
      });
      newOrder.orderItems = newOrderItems;
      this.changeOrderValue('newOrder', newOrder);
    },
  },
};
</script>

<style lang="scss">

.ol-item-container {
  display: flex;
  flex-direction: column;

  .oli-row-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .oli-input-container {
      display: flex;
      align-items: center;

      .od-extra-info-input {
        width: 40px;
        height: 40px;
        background: $NBLUE10;
        border-radius: 6px;
        padding: 0 10px;

        &:not(:last-child) {
          margin-right: 6px;
        }
      }
    }

    .oli-title {
      font-weight: 500;
    }
  }

  .od-quantity {
    background: $NBLUE10;
    padding: 5px;
    border-radius: 10px;
    width: 80px;
    display: inline-grid;
    justify-content: space-around;
    grid-auto-flow: column;
    font-size: 15px;
    font-weight: 700;
  }

  .od-delete-button {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: $TOMATO100;
    display: inline-grid;
    justify-items: center;
    align-items: center;

    &:hover {
      background-color: $TOMATO70;
    }

    .od-delete {
      width: 18px;
      height: 18px;
    }
  }
}

.od-info-row {
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;

  .od-info-sub-item {
    display: grid;
    grid-template-columns: 3fr 1fr 1fr;
    align-items: center;
    gap: 1rem;

    &.active {
      display: grid;
      grid-template-columns: 3fr 0.5fr 0.5fr 1fr 1fr;
      align-items: center;
      gap: 1rem;
    }

    .od-extra-info-input {
      width: 40px;
      height: 40px;
      background: $NBLUE10;
      border-radius: 6px;
      padding: 0 10px;
    }

    .od-quantity {
      background: $NBLUE10;
      padding: 5px;
      border-radius: 10px;
      width: 80px;
      display: inline-grid;
      justify-content: space-around;
      grid-auto-flow: column;
      font-size: 15px;
      font-weight: 700;
    }

    .od-delete-button {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      background-color: $TOMATO100;
      display: inline-grid;
      justify-items: center;
      align-items: center;

      &:hover {
        background-color: $TOMATO70;
      }

      .od-delete {
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>
